// Clients.jsx
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Classes from './Clients.module.css';
import RecordTable from './RecordTable/RecordTable';
import backend from '../../../../../api';

export default function Clients() {
  const onBoarding = useSelector((state) => state.companyInfo.info);
  const companyId = onBoarding?._id;

  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState([]); // [{ user, bookings, invoices }]

  useEffect(() => {
    let alive = true;
    async function load() {
      if (!companyId) return;
      setLoading(true);
      try {
        const { data } = await backend.get("/api/user/by-company-deep", {
          params: { companyId, role: "customer" },
        });
        if (alive) setItems(data?.items || []);
      } finally {
        if (alive) setLoading(false);
      }
    }
    load();
    return () => { alive = false; };
  }, [companyId]);

  // --- helpers: search + createdAt sorting ---
  const normalize = (s) => String(s || "").trim().toLowerCase();
  const getCreatedAt = (row) =>
    row?.user?.createdAt ||
    row?.user?.customerProfile?.createdAt ||
    row?.createdAt ||
    row?.user?.metadata?.createdAt ||
    null;
  const toTime = (v) => {
    const t = v ? new Date(v).getTime() : NaN;
    return Number.isFinite(t) ? t : 0;
  };

  const filteredAndSorted = useMemo(() => {
    const n = normalize(query);
    const filtered = !n
      ? items
      : items.filter(({ user }) => {
          const name = user?.name || `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
          const address = user?.customerProfile?.location?.address || "";
          const phone = user?.phone || "";
          const hay = `${name} ${address} ${phone} ${user?.email || ""}`.toLowerCase();
          return hay.includes(n);
        });

    // Sort by createdAt DESC (newest first)
    return [...filtered].sort((a, b) => toTime(getCreatedAt(b)) - toTime(getCreatedAt(a)));
  }, [items, query]);

  return (
    <div className={Classes.hero}>
      <div className={Classes.header}>
        <div>
          <h3 className={Classes.title3}>Clients</h3>
          <h5 className={Classes.text}>Add and manage your clients.</h5>
          {/* <div className={Classes.text} style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>
            Sorted by newest (createdAt)
          </div> */}
        </div>
        <div>
          <div className={Classes.searcCon}>
            <img src="/assets/images/search.png" alt="icon" />
            <input
              type="text"
              placeholder="Search..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </div>
        </div>
      </div>

      <RecordTable loading={loading} items={filteredAndSorted} />
    </div>
  );
}
